export default __webpack_public_path__ + "assets/4d12e2e7d2c99e911148a2f9f78a505a.png";